<card [title]="'navigator.links.reports'" style="flex: 0;">
  <section body class="sales-stock-body">
    <div class="sales-stock-row">
      <img
        class="sales-stock-illustration"
        [src]="illustrationSrc"
        alt=""
      />

      <div class="sales-stock-copy">
        <h3 class="sales-stock-heading">
          {{ 'cards.reports.sales_stock.heading' | translate }}
        </h3>
        <p class="sales-stock-description">
          {{ 'cards.reports.sales_stock.description' | translate }}
        </p>
      </div>

      <div class="retailers-section">
        <div class="retailers-track">
          <div
            class="retailer-card"
            [attr.title]="selver.name"
            (click)="openSelverReport()"
            role="button"
            tabindex="0"
            (keydown.enter)="openSelverReport()"
          >
            <div class="retailer-logo-wrap">
              <img
                class="retailer-logo"
                [src]="selver.logoSrc"
                [alt]="selver.name"
              />
            </div>
            <span class="retailer-name">{{ selver.name }}</span>
          </div>
        </div>
      </div>
    </div>
  </section>
</card>
